<template>
  <div>
    <div class="lesson-item" v-for="(item, index) of list" :key="item.id">
      
      <div class="title1" @click="jumpDetail(item)">
        <div :class="{yellow: item.study_status == 0}">
          <p class="ellipsis">
            {{ item.name }}
          </p>
          
          <span v-if="item.status == 0">学习中</span>
          <!-- <span  v-if="item.study_status == -1">未学习</span> -->
          <span  v-if="item.status == 1">已学完</span>
          
        </div>
        <van-icon name="play" color="#F08E00" v-if="item.status == -1"/>
      </div>
    </div>
  </div>
  
</template>
<script>

export default {
  props:['list','isBuy'],
  data(){
    return{
      height:0,
      top:0,
    }
  },
  computed:{
    vipInfo(){
      return this.$store.state.vipInfo
    },
    platName(){
      return this.$store.state.plat.name
    }
  },
  mounted(){
  },
  methods:{
    jumpDetail(item) {
      if(this.isBuy==0){
        this.$toast('请购买后开始学习')
        return
      }
      let url = './player2?type=1&chapter_id='+item.id+'&id='+this.$route.query.id
      this.$router.push(url)
    },
  }
}
</script>

<style scoped lang="scss">
.yellow {
    color: #F08E00 !important;
    span{
      color: #F08E00 !important;
    }
  }
.lesson-item {
  background: #F7F7F7;
  cursor: pointer;
  overflow: hidden;
  border-radius: 12px;
  margin: 0 32px 20px;
  font-size: 28px;
  padding: 20px 0;
  .title1 {
    display: flex;
    align-items: center;
    height: 60px;
    padding-left: 24px;
    padding-right: 20px;
    >div {
      flex: 1;
      font-weight: 500;
      color: #000000;
      display: flex;
      align-items: center;
      p{
        flex: 1;
       
      }
      span{
        color: #666666;
      }
    }
  }
}
</style>